import { Vector3 } from "three";
import { isPointInsideBoundary } from "./isPointInsideBoundary";


export function getClosestPointOnBoundary(point: Vector3, center: XYZ, size: XYZ, fromInside = true): Vector3 {
  const { x, y, z } = point;
  const [centerX, centerY, centerZ] = center;
  const [sizeX, sizeY, sizeZ] = size;
  const minX = centerX - sizeX / 2;
  const maxX = centerX + sizeX / 2;
  const minY = centerY - sizeY / 2;
  const maxY = centerY + sizeY / 2;
  const minZ = centerZ - sizeZ / 2;
  const maxZ = centerZ + sizeZ / 2;
  const result = new Vector3(x, y, z);
  if (!fromInside) {
    if (x < minX) {
      result.x = minX;
    }
    if (x > maxX) {
      result.x = maxX;
    }
    if (y < minY) {
      result.y = minY;
    }
    if (y > maxY) {
      result.y = maxY;
    }
    if (z < minZ) {
      result.z = minZ;
    }
    if (z > maxZ) {
      result.z = maxZ;
    }
    return result;
  }
  let closestUnit = Math.abs(result.x - minX);
  let closestAxis: Axis = 'x';
  let closestValue = minX;
  compareClosest('y', minY);
  compareClosest('z', minZ);
  compareClosest('x', maxX);
  compareClosest('y', maxY);
  compareClosest('z', maxZ);
  function compareClosest(axis: Axis, value: number) {
    const calculatedUnit = Math.abs(result[axis] - value);
    if (calculatedUnit < closestUnit) {
      closestUnit = calculatedUnit;
      closestValue = value;
      closestAxis = axis;
    }
  }
  result[closestAxis] = closestValue;
  return result;
}